<div class="roll-positions-panel" data-element="roll-positions-panel">

  <!-- Dates -->
  <fieldset class="fieldset" data-element="fieldset-dates">
    <legend>Dates</legend>

    <!-- CR-20260831-004: .param-changed = this control no longer matches what the last run sent
         (toggle => yellow selected segment; picked value => yellow box background). -->
    <dx-button-group
      [class.param-changed]="this.isChanged('date.kind')"
      [items]="this.dateKindButtons"
      keyExpr="id"
      selectionMode="single"
      stylingMode="contained"
      [selectedItemKeys]="[this.isSingle ? 'single' : 'range']"
      (onItemClick)="this.onDateKindClick($event)"
    ></dx-button-group>

    <dx-date-box *ngIf="this.isSingle"
                 [class.param-changed]="this.isChanged('date.value')"
                 [value]="this.singleDate" type="date" displayFormat="EEE dd-MMM-yy"
                 [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                 [min]="this.singleDateMin"
                 [disabledDates]="this.disabledDatesFn" (onValueChanged)="this.onSingleDate($event)"></dx-date-box>

    <!-- CR-20260904-001 (BR-W5): the boundary boxes gate on rangeDisabledDatesFn — non-tradeable days AND
         Mondays the rule still excludes. A boundary is a pick, never an exclusion edit: there is no
         mark to click and nothing here lifts an exclusion. That happens in the exclusion calendar. -->
    <div class="pair" *ngIf="!this.isSingle">
      <!-- [min] = the anchor day (owner, 2026-09-08): the short-option expiration. Every day BEFORE it
           is crossed out; the anchor day itself stays selectable. No anchor = no bound. -->
      <!-- Per-box cue (owner vrequest 2026-09-15): the Start paints on date.start, the End on
           date.end, so only the boundary that moved is yellow. date.value is still honoured. -->
      <dx-date-box [value]="this.rangeStart" type="date" displayFormat="EEE dd-MMM-yy"
                   [class.param-changed]="this.isChanged('date.start') || this.isChanged('date.value')"
                   placeholder="Start" [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                   [min]="this.rangeStartMin"
                   [disabledDates]="this.rangeDisabledDatesFn" (onValueChanged)="this.onRangeStart($event)"></dx-date-box>
      <!-- [max] = start + the "Max Query Range (days)" ORION setting (2026-09-08): the End dropdown
           offers only what the cap allows. [min] = start + 1 day (owner, 2026-09-08): End is
           FORWARD-ONLY — the Start day and everything before it are crossed out. [disabled] until a
           Start exists: there is nothing for an End to be after. -->
      <dx-date-box [value]="this.rangeEnd" type="date" displayFormat="EEE dd-MMM-yy"
                   [class.param-changed]="this.isChanged('date.end') || this.isChanged('date.value')"
                   placeholder="End" [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                   [disabled]="this.rangeEndDisabled"
                   [min]="this.rangeEndMin"
                   [max]="this.rangeEndMax"
                   [disabledDates]="this.rangeDisabledDatesFn" (onValueChanged)="this.onRangeEnd($event)"></dx-date-box>
    </div>
    <div class="dates-loading" data-element="dates-loading" *ngIf="this.expirationsLoading">
      <dx-load-indicator [height]="14" [width]="14"></dx-load-indicator>
      <span>Loading Expirations…</span>
    </div>
    <!-- The range is wider than the "Max Query Range (days)" setting allows (BR-W1; binds everyone
         since 2026-09-08). It BLOCKS Run, so it is an error, not a warning. Clears itself the moment
         the range is legal again. -->
    <div class="dates-error" data-element="dates-range-cap-message" *ngIf="this.rangeCapMessage">
      <span>{{ this.rangeCapMessage }}</span>
    </div>
  </fieldset>

  <!-- Day exclusions (blocked out on a single date) -->
  <fieldset class="fieldset" [class.disabled]="this.isSingle" data-element="fieldset-day-exclusions">
    <legend>Day Exclusions</legend>
    <dx-button-group
      [class.param-changed]="this.isChanged('exclusions.weekdays')"
      [items]="this.weekdayButtons"
      keyExpr="id"
      selectionMode="multiple"
      stylingMode="contained"
      [selectedItemKeys]="this.selectedWeekdayKeys"
      [disabled]="this.isSingle"
      (onItemClick)="this.onWeekdayClick($event)"
    ></dx-button-group>
    <p class="note" data-element="day-exclusions-note">
      Multi-Select · Complements Specific-Date Exclusions, Never Contradicts.
    </p>
    <!-- CR-20260904-001 (BR-W5): the boundary pickers no longer un-exclude anything, so the trader is told
         where the one escape hatch lives. Shown only while the weekday rule is actually in force —
         a hint about bringing days back is false once every button is off. CR-20260915-002: any
         excluded weekday, not Mondays only. -->
    <p class="note" data-element="weekday-override-hint" *ngIf="this.showWeekdayOverrideHint">
      To Bring Back a Day the Weekday Rule Excluded, Open Exclude Specific Dates And Click it.
    </p>
  </fieldset>

  <!-- Exclude specific dates (blocked out on a single date) -->
  <fieldset class="fieldset" [class.disabled]="this.isSingle" data-element="fieldset-date-exclusions">
    <legend>Exclude Specific Dates</legend>
    <div *ngIf="!this.isSingle">
      <!-- Collapsed trigger: the WHOLE area is click-to-expand (mirrors the breadcrumb strip). Empty ->
           a centered prompt; with committed dates -> read-only pills (edit by clicking to re-open). -->
      <div class="exclusion-trigger" data-element="exclusion-trigger"
           [class.has-dates]="this.excludedDatePills.length > 0"
           [class.param-changed]="this.isChanged('exclusions.dates')"
           *ngIf="!this.calendarOpen"
           (click)="this.openCalendar()">
        <span class="exclusion-prompt" data-element="exclusion-prompt"
              *ngIf="this.excludedDatePills.length === 0">Choose Dates to Exclude…</span>
        <span class="exclusion-pill" data-element="exclusion-pill"
              *ngFor="let pill of this.excludedDatePills">{{ pill }}</span>
      </div>
      <ets-apg-exclusion-calendar *ngIf="this.calendarOpen"
                                  [inputs]="this.inputs"
                                  [availableExpirations]="this.availableExpirations"
                                  (apply)="this.onExclusionsApply($event)"
                                  (cancel)="this.onExclusionsCancel()"></ets-apg-exclusion-calendar>
    </div>
    <p class="note" *ngIf="this.isSingle">Not Applicable For a Single Date.</p>
  </fieldset>

  <!-- Directional bias -->
  <fieldset class="fieldset" data-element="fieldset-bias">
    <legend>Directional Bias</legend>
    <div class="bias-row">
      <dx-button-group
        class="bias-yesno"
        [class.param-changed]="this.isChanged('bias.enabled')"
        [items]="this.biasButtons"
        keyExpr="id"
        selectionMode="single"
        stylingMode="contained"
        [selectedItemKeys]="[this.biasEnabled ? 'yes' : 'no']"
        (onItemClick)="this.onBiasClick($event)"
      ></dx-button-group>
      <span class="divider" *ngIf="this.biasEnabled"></span>
      <dx-button-group *ngIf="this.biasEnabled"
        class="bias-dirs"
        [class.param-changed]="this.isChanged('bias.direction')"
        [items]="this.biasDirections"
        keyExpr="id"
        selectionMode="single"
        stylingMode="contained"
        [selectedItemKeys]="this.biasDir ? [this.biasDir] : []"
        (onItemClick)="this.onBiasDirClick($event)"
      ></dx-button-group>
    </div>
    <p class="note">Direction Buttons Revealed Only When Yes is Selected · Auto Runs Its Own Sub-Skill.</p>
  </fieldset>

</div>
